// extracted by mini-css-extract-plugin
export default {"swiperSlide":"NewsWidgets_swiperSlide__MgPOp","newsContent":"NewsWidgets_newsContent__i2Dyk"};